import { Timestamp } from "firebase/firestore";

export const formatDate = (timestamp: any): string => {
  if (!timestamp) return "";
  const date = timestamp.toDate();
  return date.toLocaleString(); // Convert to a locale string format
};

export const timestampToDate = (timestamp: Timestamp): Date => {
  return new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
};

export const copyTextToClipboard = (text: string) => {
  navigator.clipboard.writeText(text).then(
    () => {},
    (err) => {
      console.error("Could not copy text: ", err);
    }
  );
};

export const getLocalStorageItem = (key: string) => {
  try {
    const cachedData = localStorage.getItem(key);
    return cachedData ? JSON.parse(cachedData) : null;
  } catch (error) {
    console.error("Error loading cached data:", error);
    return null;
  }
};

export const setLocalStorageItem = async (data: any, key: string) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error("Error saving cached data:", error);
  }
};

export interface IYoutubeMetaData {
  author_name: string;
  author_url: string;
  html: string;
  provider_name: string;
  provider_url: string;
  thumbnail_url: string;
  title: string;
  type: string;
  version: string;
  width: number;
  height: number;
  thumbnail_height: number;
  thumbnail_width: number;
}

export const fetchYouTubeMetadata = async (url: string) => {
  const urlMetadata = `https://www.youtube.com/oembed?url=${url}&format=json`;
  const response = await fetch(urlMetadata);
  const result = response.json();

  return result as Promise<IYoutubeMetaData>;
};

export function makeRandomString(length: number): string {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const generateIdByNowDate = (): string => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  // songId가 없으면 userId + MMDDHHSS 형식으로 ID 생성
  return `${month}월${day}일${hours}:${minutes}:${seconds}`;
};

export function throttle<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  let lastExecuted = 0;

  // 실제 함수를 실행하는 래퍼 함수
  const wrapper = function (this: any, ...args: Parameters<T>) {
    const now = Date.now();

    // 마지막 실행 시간과 현재 시간의 차이가 대기 시간보다 크면 즉시 실행
    if (lastExecuted === 0 || now - lastExecuted >= wait) {
      func.apply(this, args);
      lastExecuted = now;
      return;
    }

    // 이전 타이머가 있다면 클리어
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }

    // 남은 대기 시간만큼 타이머 설정
    const remaining = wait - (now - lastExecuted);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
      lastExecuted = Date.now();
      timeoutId = null;
    }, remaining);
  };

  // cancel 메소드 추가
  wrapper.cancel = function () {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    lastExecuted = 0;
  };

  return wrapper;
}
